import React from 'react';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Stats from '../components/Stats';
import Community from '../components/Community';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import CTAFinal from '../components/CTAFinal';
import Footer from '../components/Footer';

const Landing = () => {
  return (
    <div className="min-h-screen overflow-hidden">
      <Hero />
      <Stats />
      <Features />
      <Testimonials />
      <Community />
      <FAQ />
      <CTAFinal />
      <Footer />
    </div>
  );
};

export default Landing;
